export const workspacePanelClassName = 'grid gap-4 rounded-xl border border-slate-200 bg-white p-5 shadow-sm'
export const workspaceHeaderClassName = 'flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'
export const workspaceSectionHeaderClassName = 'flex items-start justify-between gap-3'
export const workspaceKickerClassName = 'text-xs font-semibold uppercase tracking-wide text-slate-500'
export const workspaceMutedTextClassName = 'text-sm leading-6 text-slate-500'
export const workspaceNoteTextClassName = 'text-xs leading-5 text-slate-500'
export const workspaceSummaryGridClassName = 'grid gap-3 md:grid-cols-2 xl:grid-cols-4'
export const workspaceMetricClassName = 'grid gap-1 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm'
export const workspaceFieldClassName = 'grid gap-2'
export const workspaceFieldLabelClassName = 'text-sm font-medium text-slate-700'
export const workspaceInputClassName = 'w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-slate-900 outline-none transition focus:border-blue-300 focus:ring-2 focus:ring-blue-100'
export const workspaceActionsClassName = 'flex flex-wrap gap-2.5'
export const workspaceGridClassName = 'grid gap-4'
export const workspaceDetailGridClassName = 'grid gap-4 xl:grid-cols-2'
export const workspaceCardClassName = 'grid gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm'
export const workspaceEmptyClassName = 'rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-5 text-sm leading-6 text-slate-500'
export const workspaceListClassName = 'grid gap-3'
export const workspaceInfoListClassName = 'grid gap-3 rounded-[20px] border border-slate-200/70 bg-slate-50 p-4'
export const workspaceTableClassName = 'grid gap-px overflow-hidden rounded-[24px] border border-slate-200/70 bg-slate-200'
export const workspaceTableCardRowClassName = 'grid gap-3 bg-white px-4 py-4 text-sm leading-6 text-slate-700 lg:items-start'

export function workspaceTagClassName(active = false) {
  return [
    'inline-flex items-center rounded-full border px-3 py-1.5 text-sm font-medium',
    active
      ? 'border-transparent bg-[linear-gradient(135deg,#0b74de_0%,#0099ff_100%)] text-white shadow-[0_10px_22px_rgba(11,116,222,0.18)]'
      : 'border-slate-200 bg-slate-100 text-slate-700',
  ].join(' ')
}

export function workspaceBadgeClassName(accent = false) {
  return [
    'inline-flex items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.08em]',
    accent ? 'bg-amber-100 text-amber-800' : 'bg-slate-100 text-slate-600',
  ].join(' ')
}

export function workspaceSelectableCardClassName(active = false) {
  return [
    'grid gap-3 rounded-[24px] border bg-white p-5 text-left shadow-sm transition',
    active
      ? 'border-sky-300 bg-sky-50 shadow-[0_10px_22px_rgba(11,116,222,0.12)]'
      : 'border-slate-200/70 hover:border-sky-200 hover:shadow-[0_10px_22px_rgba(15,23,42,0.08)]',
  ].join(' ')
}
